import moment from 'moment'

import isBeforeDay from './is-before-day'
import isSameDay from './is-same-day'

export default function isAfterDay(a, b) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false
  return !isBeforeDay(a, b) && !isSameDay(a, b)
}
